import { onMounted, ref } from 'vue'

export type ClientOs = 'mac' | 'windows' | 'linux' | 'unknown'

// Detect the visitor's desktop OS so the install dialog can lead with the right download and steps.
// Resolved on mount (never during SSR, where `navigator` is absent); mobile stays 'unknown' since
// the desktop client doesn't run there and we'd rather show the platform picker than a wrong guess.
export function useClientOs() {
  const os = ref<ClientOs>('unknown')

  onMounted(() => {
    const haystack = `${navigator.userAgent} ${navigator.platform ?? ''}`
    // iPadOS 13+ reports a desktop "Macintosh" UA with no "iPad"; a touch-capable Mac is really an iPad.
    const touchMac = /Mac/i.test(haystack) && navigator.maxTouchPoints > 1
    if (/Android|iPhone|iPad|iPod/i.test(haystack) || touchMac) os.value = 'unknown'
    else if (/Mac/i.test(haystack)) os.value = 'mac'
    else if (/Win/i.test(haystack)) os.value = 'windows'
    else if (/Linux|X11/i.test(haystack)) os.value = 'linux'
  })

  return os
}
